// Résolution de l'URL cible d'un sticker cliqué dans une preview de story
const withProtocol = (url) => /^https?:\/\//i.test(url) ? url : `https://${url}`;

const profileUrl = (username, network) => {
    if (!username) return null;
    const clean = String(username).replace(/^@/, '').trim();
    if (!clean) return null;
    return network === 'facebook' ? `https://www.facebook.com/${clean}` : `https://www.instagram.com/${clean}/`;
};

const textMentionUrl = (mention) => {
    if (!mention || !mention.mention) return null;
    const { instagram, facebook } = mention.mention;
    if (instagram && instagram.id) return profileUrl(instagram.id, 'instagram');
    if (facebook) return facebook.link || profileUrl(facebook.username || facebook.id, 'facebook');
    return null;
};

const placeUrl = (place) => {
    if (!place) return null;
    const igId = place.pk || place.external_id;
    if (igId) return `https://www.instagram.com/explore/locations/${igId}/`;
    const loc = place.location || {};
    if (loc.lat != null && loc.lng != null) return `https://www.google.com/maps/search/?api=1&query=${loc.lat},${loc.lng}`;
    const query = [place.name, loc.street, loc.city, loc.zip, loc.country].filter(Boolean).join(' ');
    return query ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}` : null;
};

export function getStickerTargetUrl(sticker, network, clickedEl) {
    const data = (sticker && sticker.data) || {};

    switch (sticker && sticker.type) {
        case 'link':
            return data.link ? withProtocol(data.link) : null;
        case 'mention':
            return data.mention && data.mention.id ? profileUrl(data.mention.id, network) : null;
        case 'hashtag': {
            const tag = (data.hashtag || '').replace(/<[^>]*>/g, '').replace(/^#/, '').trim();
            if (!tag) return null;
            return network === 'facebook'
                ? `https://www.facebook.com/hashtag/${encodeURIComponent(tag)}`
                : `https://www.instagram.com/explore/tags/${encodeURIComponent(tag)}/`;
        }
        case 'localisation':
            return placeUrl(data.place);
        case 'text': {
            const mentionEl = clickedEl && clickedEl.closest('.tag-mention');
            const id = mentionEl && mentionEl.getAttribute('idmention');
            return id && data.mentions ? textMentionUrl(data.mentions[id]) : null;
        }
        default:
            return null;
    }
}

// Widgets sans destination externe, affichables en vue focus lecture seule
export const FOCUSABLE_STICKER_TYPES = ['question', 'survey', 'slider', 'countdown', 'product', 'music', 'gif', 'image', 'text', 'mention', 'hashtag'];

// Retrouve le sticker le plus haut sous le point (x, y) du conteneur
export function findStickerAtPoint(container, stickers, x, y) {
    const elements = document.elementsFromPoint(x, y).filter(el => container.contains(el));

    for (const element of elements) {
        const wrapper = element.closest('.story-maker-draggable-sticker, .link-sticker-fixed');
        if (!wrapper) continue;

        const sticker = wrapper.classList.contains('link-sticker-fixed')
            ? stickers.find(s => s.type === 'link')
            : stickers.find(s => wrapper.classList.contains(`id-${s.id}`));

        if (sticker) return { sticker, element };
    }
    return null;
}
